/**
 * Extensões de browser (MetaMask e similares) injetam script em localhost.
 * O overlay do bundler trata o throw da extensão como se fosse erro do app.
 * O produto não usa Web3 — isto só impede que o ruído derrube a UI de dev.
 */
const EXTENSION_NOISE =
  /chrome-extension:\/\/|moz-extension:\/\/|Failed to connect to MetaMask|nkbihfbeogaeaoehlefnkodbefgpgknn/i;

function isExtensionNoise(message?: string, filename?: string, stack?: string): boolean {
  return EXTENSION_NOISE.test([message, filename, stack].filter(Boolean).join(' '));
}

export {};

if (typeof window !== 'undefined') {
  window.addEventListener(
    'error',
    (event) => {
      const stack = event.error instanceof Error ? event.error.stack : undefined;
      if (isExtensionNoise(event.message, event.filename, stack)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      const reason = event.reason as { message?: string; stack?: string } | string | undefined;
      const msg = typeof reason === 'string' ? reason : reason?.message;
      const stack = typeof reason === 'object' && reason ? reason.stack : undefined;
      if (isExtensionNoise(msg, undefined, stack)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}
